export default {
  name: 'tnf-stg',
  appId: 'wx9aaf50526558a418',
  wechatId: '211'
};